import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-export-progress-modal',
  templateUrl: './export-progress-modal.component.html',
  styleUrls: ['./export-progress-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf, TranslateModule]
})
export class ExportProgressModalComponent implements OnInit, OnDestroy {
  @Input() progress$: BehaviorSubject<number>;
  @Input() format: string = '';

  progress = 0;
  private sub: Subscription;

  ngOnInit() {
    if (this.progress$) {
      this.sub = this.progress$.subscribe(val => {
        this.progress = val;
      });
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
